import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import './ConfirmationPopup.css';

/**
 * Displays a shared confirmation dialog for an action.
 * @param {Object} props - Component properties.
 * @param {string} props.title - Action title displayed in the dialog header.
 * @param {string} [props.message] - Optional explanatory message displayed below the header.
 * @param {Function} props.onConfirm - Callback invoked when Proceed is selected.
 * @param {Function} props.onCancel - Callback invoked when Cancel is selected.
 * @param {boolean} [props.isSubmitting=false] - Whether the action is currently being submitted.
 * @param {boolean} [props.isTestMode=false] - Whether to show the test-mode prefix and styling.
 * @returns {JSX.Element} The confirmation dialog.
 */
function ConfirmationPopup({
  title,
  message,
  onConfirm,
  onCancel,
  isSubmitting = false,
  isTestMode = false,
}) {
  return (
    <div className="confirmation-popup">
      <div className="confirmation-content">
        <div className="confirmation-header">
          <FaExclamationTriangle className="confirmation-icon" />
          <h3>
            {isTestMode ? 'TEST MODE: ' : ''}
            {title}
          </h3>
        </div>
        {message && <p>{message}</p>}
        <div className="confirmation-buttons">
          <button className={`cancel-button ${isTestMode ? 'test-mode' : ''}`} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={`confirm-button ${isTestMode ? 'test-mode' : ''}`}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationPopup;
